import React from 'react'
import PropTypes from 'prop-types'
import RequestRejectAction from 'components/Actions/RequestReject'

const RequestRejectPage = ({ match }) => (
  <RequestRejectAction token={match.params.token} />
)

RequestRejectPage.propTypes = {
  match: PropTypes.object.isRequired
}

export default RequestRejectPage
